import React from "react";

export const COMMON_ALT = "911win CASINO";
export const COMMON_LOADING = 1500;
export const WEB_PATH = "https://911win.me/";
export const WEB = "https://911win.me/";
